module.exports = __webpack_public_path__ + "img/sld_scb_19_t1_b1.4d28e34c.svg";